import { useEffect, useState } from 'react'
import sparkel from '../../../../resources/sparkel.min.svg'
import './SparkleOverlay.css'

const COLORS = [
  'var(--color_primary_t300)',
  'var(--color_primary_t500)',
  'var(--color_secondary_t500)'
]

const SparkleOverlay = () => {
  const [sparkles, setSparkles] = useState([])

  useEffect(() => {
    // Generate random sparkle positions
    const generatedSparkles = Array.from({ length: 20 }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      top: Math.random() * 100,
      size: 15 + Math.random() * 20,
      rotation: Math.random() * 360,
      animationDelay: Math.random() * 3,
      animationDuration: 2 + Math.random() * 2,
      color: COLORS[Math.floor(Math.random() * COLORS.length)]
    }))
    setSparkles(generatedSparkles)
  }, [])

  return (
    <div className='sparkle-overlay'>
      {sparkles.map(sparkle => (
        <div
          key={sparkle.id}
          className='sparkle-overlay-item'
          style={{
            left: `${sparkle.left}%`,
            top: `${sparkle.top}%`,
            width: `${sparkle.size}px`,
            height: `${sparkle.size}px`,
            backgroundColor: `${sparkle.color}`,
            maskImage: `url(${sparkel})`,
            WebkitMaskImage: `url(${sparkel})`,
            maskSize: 'contain',
            WebkitMaskSize: 'contain',
            maskRepeat: 'no-repeat',
            WebkitMaskRepeat: 'no-repeat',
            maskPosition: 'center',
            WebkitMaskPosition: 'center',
            animationDelay: `${sparkle.animationDelay}s`
          }}
        />
      ))}
    </div>
  )
}

export default SparkleOverlay
